var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsDownSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FF3D00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 16.59C25.4142 16.59 25.75 16.2542 25.75 15.84C25.75 15.4258 25.4142 15.09 25 15.09C24.5858 15.09 24.25 15.4258 24.25 15.84C24.25 16.2542 24.5858 16.59 25 16.59Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3 28.27C17.82 28.64 18.42 28.75 18.95 28.75H18.94C18.9433 28.75 18.9467 28.75 18.95 28.75C19.5773 28.7484 20.0854 28.5939 20.2149 28.5546C20.2207 28.5528 20.2257 28.5513 20.23 28.55C20.53 28.45 20.74 28.16 20.74 27.84V24.15L22.3 22.59H22.99L22.9957 22.59L23 22.59H27C27.41 22.59 27.75 22.25 27.75 21.84V13.84C27.75 13.43 27.41 13.09 27 13.09H23.1293C22.5934 12.9322 19.9918 12.2176 15.28 12.1C14.16 12.1 13.21 12.85 13 13.94C12.71 15.48 12.35 17.92 12.27 20.78C12.26 21.26 12.44 21.72 12.77 22.06C13.1 22.4 13.54 22.59 14.02 22.59H16.26V25.84C16.26 26.95 16.61 27.77 17.3 28.27ZM23.75 14.59V21.09H26.25V14.59H23.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownSelected);
export default __webpack_public_path__ + "static/media/thumbs_down_selected.724afd05b7eaa6151e4058d87b064739.svg";
export { ForwardRef as ReactComponent };